import React, { useEffect, useState } from "react";
import Modal from "../modals/Modal";
import ModalMobile from "../modals/ModalMobile";
import axios from 'axios';
import { API_URL } from '../../const/api';
import {
  ButtonClose,
  Container,
  Form,
  ModalTitle,
  Row,
  CheckBoxContainer,
  InputContainer,
  Button,
  ButtonStep,
  InputConfirmPass,
  WarningPass,
  InputCL,
  Guion
} from "./RegisterElements";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import InfoIcon from '@mui/icons-material/Info';
import { FormControlLabel, Switch } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
  selectRegisterModal,
  setShowUserRegisterModal,
} from "../../features/modals/modalsSlice";
import { selectDetectedCountry, selectLogged } from "../../features/user/userSlice";
import { useForm } from "../../hooks/useForm";
import { initialFormRegister, validarCedula, validarNombre, validationsForm } from "../../utils/validateForm";
import InputBox from "./InputBox";
import SelectBox from "./SelectBox";
import TypeDocument from "./TypeDocument";
import CountryBox from "./CountryBox";
import PhoneBox from "./PhoneBox";
import CustomCheckbox from "../CustomCheckbox";
import Swal from "sweetalert2";
import logo from "../../assets/images/escudo-mb.svg";
import { PRIMARY, SECONDARY } from "../../const/colors";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactPixel from "react-facebook-pixel";
import terms from "../../assets/pdfs/Terms & Conditions.pdf";
import terminos from "../../assets/pdfs/Términos & Condiciones 2024 version GLI.pdf";
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Padding } from "@mui/icons-material";
import { countries } from "../../const/countries";

const Register = ({name}) => {
  const [t, i18n] = useTranslation("global");
  const registerModal = useSelector(selectRegisterModal);
  const isLoged = useSelector(selectLogged);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(false);
  const [params] = useSearchParams();
  const [agente, setAgente] = useState();
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [confirmNewPasswordValid, setConfirmNewPasswordValid] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
  const handleCheck = (event) => {
    setChecked(event.target.checked);
  };
  const steps = [
    t("sign-in.titlestep1"),
    t("sign-in.titlestep2"),
    t("sign-in.titlestep3"),
    t("sign-in.titlestep4"),
  ];
  const {
    form,
    errors,
    handleChange,
    handleSubmit,
    handleBlur,
    handleCountry,
    handleClear,
    handleRadioChange,
    loading,
  } = useForm(initialFormRegister, validationsForm);

  const detectedCountry = useSelector(selectDetectedCountry)
  const [showLetraInput, setShowLetraInput] = useState(false)

  useEffect(()=>{
    if(detectedCountry==='CL' && (form.type_doc==='rut' || form.type_doc==='run')) setShowLetraInput(true)
      else setShowLetraInput(false)
  },[form])

  useEffect(()=>{
    if(form.clave!==confirmNewPassword) setConfirmNewPasswordValid(true)
    else setConfirmNewPasswordValid(false)
  },[form.clave, confirmNewPassword])

  const handleClose = (e) => {
    if (e) {
      e.preventDefault();
    }
    handleClear();
    if (window.location.pathname.includes("registro")) {
      navigate("/");
    }
    dispatch(setShowUserRegisterModal(false));
  };

  const confirmClose = (e) => {
    e.preventDefault();
    Swal.fire({
      html:
        `<h3>${t("modal-leave-register.title")}</h3> ` +
        `<p class="register-p">${t("modal-leave-register.subtitle")}</p>` +
        `<b>${t("modal-leave-register.info")}</b>`,
      imageUrl: logo,
      imageWidth: 100,
      imageHeight: 70,
      showCancelButton: true,
      confirmButtonText: t("modal-leave-register.btn-stay"),
      cancelButtonText: t("modal-leave-register.btn-leave"),
      allowOutsideClick: false,
      background: SECONDARY,
      color: "#fff",
      confirmButtonColor: PRIMARY,
    }).then((result) => {
      if (result.isConfirmed) {
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        handleClose();
      }
    });
  };

  useEffect(() => {
    ReactPixel.init("321003680044957");
    ReactPixel.pageView();
    if (params.get("agente")) {
      setAgente(params.get("agente"));
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    handleChange({ name: "codigoAgente", value: agente });
  }, [agente]);

  const changemodal = useMediaQuery('(min-width:768px)');

  const handleToggleConfirmNewPasswordVisibility = () => {
    setShowConfirmNewPassword((prevShowConfirmNewPassword) => !prevShowConfirmNewPassword);
  };

  const handleConfirmNewPasswordChange = (value) => {
    setConfirmNewPassword(value);
    if (form.clave !== value) {
      setConfirmNewPasswordValid(true);
    } else {
      setConfirmNewPasswordValid(false);
    }
  };
  // datos para activar el step de react 

  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [stepFailed ,setStepFailed]= useState(false);
  const [serverError, setServerError] = useState('');
  const [errorLetra, setErrorLetra] = useState('');
  const [activeBtn, setActiveBtn] = useState('');
  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleFocusLetra = (e) => {
    const {value} = e.target
    if(value==='') setErrorLetra('El campo no puede estar vacio.')
    else setErrorLetra('')
  }

  const isStepFailed = (step) => {
    if(form.nombre == "" || form.fecha_nac == "" || form.type_doc == "" || form.cedula == ""){
      return step === 0;
    }
    if(form.country == "" || form.address == "" || form.telefono == "" || form.email == ""){
      return step === 1;
    }
    if(form.usuario == "" || form.clave == "" || form.Confirmclave == "" || form.moneda == ""){
      return step === 2;
    }
  };
  
  const handleNext = async (e) => {
    setActiveBtn(true);
    if(activeStep == 0){
     try{
        const resCedula = await axios.post(API_URL+'validarFormulario', {["cedula"]: form.cedula});
        // if(resCedula.data.response == !null){
          if(resCedula.data.response.error===1 || errors.cedula!==undefined) {
            setStepFailed(true);
            setActiveBtn(false);
            return;
          }
          const resNombre = form.nombre.trim();
          if(form.nombre !== resNombre){
            setStepFailed(true);
            setActiveBtn(false);
            return;
          }
        // }
      }catch (error) {
        setServerError(null);
      }
      if(form.nombre === "" || form.fecha_nac === "" || form.type_doc === "" || form.cedula === ""){
        setStepFailed(true);
        setActiveBtn(false);
        return
      } else if(!validarNombre(form.nombre)) {
        setStepFailed(true);
        setActiveBtn(false);
        return
      } else if(validarCedula(form.type_doc, form.cedula)) {
        setStepFailed(true);
        setActiveBtn(false);
        return
      } else if(showLetraInput) {
        if(form.letraONumero==='') {
          setStepFailed(true);
          setActiveBtn(false);
        return
        }
      } else{
        setStepFailed(false);
      }
    }
    if(activeStep == 1){
      try{
        const resTelefono = await axios.post(API_URL+'validarFormulario', {telefono:`${form.countryCode+" "+form.telefono}`});
        const resEmail = await axios.post(API_URL+'validarFormulario', {["email"]: form.email});
      
        // if(resCedula.data.response == !null){
          if(resTelefono.data.response.error===1 || errors.telefono!==undefined){
            setStepFailed(true);
            setActiveBtn(false);
            return;
          }
          if(resEmail.data.response.error===1){
            setStepFailed(true);
            setActiveBtn(false);
            return;
          }
        // }
      }catch (error) {
        setServerError(null);
      }
      if(detectedCountry==='VE'||detectedCountry==='BR') {
        if(form.area==='') {
          setStepFailed(true);
          setActiveBtn(false);
          return;
        }
      }
      else if(form.country == "" || form.address == "" || form.telefono == "" || form.email == ""){
        setStepFailed(true);
        setActiveBtn(false);
        return;
      }else{
        setStepFailed(false);
      }
    }
    if(activeStep == 2){
      try{
        const resUsuario = await axios.post(API_URL+'validarFormulario', {["usuario"]: form.usuario});
        // console.log(resUsuario.data);
        // if(resCedula.data.response == !null){
          if(resUsuario.data.response.error===1){
            setStepFailed(true);
            setActiveBtn(false);
            return;
          }

          if(form.usuario !== form.usuario.trim()){
            setStepFailed(true);
            setActiveBtn(false);
            return;
          }
        // }
      }catch (error) {
        setServerError(null);
      }

      if(errors.clave || errors.usuario || form.usuario == "" || form.clave == "" || confirmNewPassword == ""|| form.moneda == "default"){
        setStepFailed(true);
        setActiveBtn(false);
        return;
      }else{
        
        handleConfirmNewPasswordChange(confirmNewPassword);
        if(confirmNewPassword == form.clave){
          if(form.clave.length >= 8){
            setStepFailed(false);
          }else{
            setActiveBtn(false);
            return;
          }
        }else{
          setStepFailed(true);
          setActiveBtn(false);
          return;
        }

      }
      
    }
    if(activeStep == 3){
      if(form.over18 == "" || form.acceptConditions == "" || form.acceptConditionsPromo == ""){
        setStepFailed(true);
        setActiveBtn(false);
        return;
      }else{
        setStepFailed(false);
      }
    }

    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
    setActiveBtn(false);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  useEffect(()=>{
    const pais = countries.find(x=>x.flag===detectedCountry)
    if(pais) {
      handleChange({target: {name:'country', value: detectedCountry}})
    }
  },[detectedCountry])

  // fin de los step 

  return (
    !isLoged && (
      <>
        <Helmet>
          <title>MasterBets365 | Apuestas deportivas | Casino online</title>
          <meta
            name="description"
            content={
              "¿Estás listo para apostar y ganar desde casa? Conoce MasterBets365, casino online. Apuestas deportivas, hipódromo, ruleta y mucho más."
            }
          ></meta>
        </Helmet>
        <noscript>
          <img
            height="1"
            alt=""
            width="1"
            style={{ display: "none" }}
            src="https://www.facebook.com/tr?id=321003680044957&ev=PageView&noscript=1"
          />
        </noscript>
        {changemodal ? 
          <Modal
            open={registerModal}
            maxWidth="md"
            fullWidth={false}
            handleClose={confirmClose}
            children={
              <Container>
                <ButtonClose onClick={confirmClose}>
                  <CloseIcon />
                </ButtonClose>
                <ModalTitle>{t("sign-in.title")}</ModalTitle>
                <Form onSubmit={handleSubmit} autoComplete="off">
                  <Box sx={{ width: '100%' }}>
                      <Stepper activeStep={activeStep} alternativeLabel sx={{marginBottom:'2rem'}}> 
                        {steps.map((label, index) => {  
                          const stepProps = {};
                          const labelProps = {};

                          if (isStepSkipped(index)) {
                            stepProps.completed = false;
                          }

                          // if(stepFailed == true){
                          //   if (isStepFailed(index)) {
                          //     labelProps.optional = (
                          //       <Typography variant="caption" color="error">
                          //         {t("sign-in.stepNoCompleto")}
                          //       </Typography>
                          //     );
                          //     labelProps.error = true;
                          //   }
                          // }
                          
                          return (
                            <Step key={label} {...stepProps}>
                              <StepLabel {...labelProps} 
                                sx={{
                                  "& .MuiStepIcon-root":{
                                    color:"white",
                                    fontWeight: "bold",
                                    fontSize: "28px",
                                  },
                                  "& .MuiStepIcon-root.Mui-active": {
                                    color: "#ffce05",
                                  },
                                  "& .MuiStepIcon-text":{
                                    fill: "#000",
                                  },
                                  "& .MuiStepIcon-root.Mui-completed":{
                                    color:"#2e7d32",
                                  },
                                  ".MuiStepLabel-label":{
                                    fontWeight:"bold!important",
                                    color:"#fff!important",
                                    fontFamily:"'Gotham', 'sans-serif'",
                                    textTransform: "uppercase",
                                    fontSize: "0.8rem",
                                  },
                                  ".MuiStepIcon-root.Mui-error": {
                                      color: "#d32f2f",
                                  }
                                }}
                              >{label}</StepLabel>
                            </Step>
                          );
                        })}
                      </Stepper>
                      {activeStep === steps.length ? (
                        <React.Fragment>
                            <div>
                              All steps completed - you are finished
                            </div>
                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                              <Box sx={{ flex: '1 1 auto' }} />
                              <Button >Iniciar Sesión</Button>
                            </Box>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                            {activeStep == 0 ? (
                              <React.Fragment>
                                <Row>
                                  <InputBox
                                    label={t("sign-in.lbl-fullname")}
                                    placeholder={t("sign-in.input-fullname")}
                                    val={form.nombre}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="nombre"
                                    error={errors.nombre}
                                    type="text"
                                  />
                                  <InputBox
                                    label={t("sign-in.lbl-birth")}
                                    placeholder={t("sign-in.input-birth")}
                                    val={form.fecha_nac}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="fecha_nac"
                                    error={errors.fecha_nac}
                                    type="date"
                                  />
                                </Row>
                                <Row>
                                  <TypeDocument
                                    label={t("sign-in.input-doc")}
                                    val={form.type_doc}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="type_doc"
                                    placeholder={t("sign-in.placeholder-doc")}
                                    error={errors.tipo_doc}
                                    className={showLetraInput ? 'showLetra' : ''}
                                  />

                                  {!showLetraInput &&
                                  <InputBox
                                    label={t("sign-in.lbl-id")}
                                    placeholder={t("sign-in.input-id")}
                                    val={form.cedula}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="cedula"
                                    error={errors.cedula}
                                    type="text"
                                    />
                                    }
                                    {showLetraInput && <InputCL>
                                      <InputBox
                                        label={t("sign-in.lbl-id")}
                                        placeholder={t("sign-in.input-id")}
                                        val={form.cedula}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        name="cedula"
                                        error={errors.cedula}
                                        type="text"
                                      /> 
                                      <span style={{color: 'white', fontSize: '2rem', margin: 'auto 0.2rem', verticalAlign: 'bottom'}}>-</span>
                                      <InputBox
                                        label={'Letra o Núm'}
                                        placeholder={'Letra o Núm'}
                                        val={form.letraONumero}
                                        handleChange={handleChange}
                                        handleBlur={handleFocusLetra}
                                        name="letraONumero"
                                        error={errorLetra}
                                        type="text"
                                      />
                                    </InputCL> }
                                </Row>
                              </React.Fragment>
                              ) : (
                              <React.Fragment>
                              </React.Fragment>
                            )}
                            {activeStep == 1 ? (
                              <React.Fragment>
                                <Row>
                                  <CountryBox
                                    label={t("sign-in.input-country")}
                                    val={form.country}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="country"
                                    error={errors.country}
                                    placeholder={t("sign-in.placeholder-country")}
                                  />
                                  <InputBox
                                    label={t("sign-in.input-address")}
                                    placeholder={t("sign-in.placeholder-address")}
                                    val={form.address}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="address"
                                    error={errors.address}
                                    type="text"
                                  />
                                </Row>
                                <Row>
                                  <PhoneBox
                                    value={form.telefono}
                                    handleCountry={handleCountry}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    error={errors.telefono}
                                    mycountry={form.country}
                                    area={form.area}
                                  />
                                  <InputBox
                                    label={t("sign-in.lbl-email")}
                                    placeholder={t("sign-in.input-email")}
                                    val={form.email}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="email"
                                    error={errors.email}
                                    type="email"
                                  />
                                  
                                </Row>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                              </React.Fragment>
                            )}
                            {activeStep == 2 ? (
                              <React.Fragment>
                                <Row>
                                  <InputBox
                                    label={t("sign-in.lbl-user")}
                                    placeholder={t("sign-in.input-user")}
                                    val={form.usuario}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="usuario"
                                    error={errors.usuario}
                                    type="text"
                                  />
                                  <SelectBox
                                    label={t("sign-in.lbl-currency")}
                                    val={form.moneda}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="moneda"
                                    placeholder={t("sign-in.input-currency")}
                                    error={errors.moneda}
                                  />
                                </Row>
                                <Row>
                                  <InputBox
                                    label={t("sign-in.lbl-password")}
                                    placeholder={t("sign-in.input-password")}
                                    val={form.clave}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="clave"
                                    error={errors.clave}
                                    type="password"
                                  />
                                  <InputContainer>
                                    <label style={{fontSize: "0.8rem",margin: "0.2rem 0px",textTransform:"uppercase"}}>{t(`password.lbl-4`)}</label>
                                    <div style={{ position: "relative", width: "100%" }}>
                                      <InputConfirmPass
                                        type={showConfirmNewPassword ? "text" : "password"}
                                        value={confirmNewPassword}
                                        placeholder={t(`password.lbl-5`)}
                                        style={{ width: "100%" }}
                                        className={confirmNewPasswordValid ? "error" : "correct"}
                                        onChange={(e) => {
                                          handleConfirmNewPasswordChange(e.target.value);
                                        }}
                                      />
                                      <span
                                        style={{
                                          position: "absolute",
                                          top: "25px",
                                          transform: "translateY(-50%)",
                                          right: "1%",
                                          color:"#ffce05",
                                          cursor:"pointer"
                                        }}
                                        onClick={handleToggleConfirmNewPasswordVisibility}
                                      >
                                        {showConfirmNewPassword ? (
                                          <VisibilityOffIcon />
                                        ) : (
                                          <VisibilityIcon />
                                        )}
                                      </span>
                                      { confirmNewPasswordValid ? (
                                        <WarningPass>
                                          <InfoIcon/>{t("password.error-8")}
                                        </WarningPass>) : ( 
                                          ""
                                      )}
                                      
                                    </div>
                                  </InputContainer>
                                </Row>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                              </React.Fragment>
                            )}
                            {activeStep == 3 ? (
                              <React.Fragment>
                                <Row>
                                  <InputContainer>
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          checked={checked}
                                          onChange={handleCheck}
                                          inputProps={{ "aria-label": "controlled" }}
                                        />
                                      }
                                      label={t("sign-in.lbl-code")}
                                    />
                                    <input
                                      type="text"
                                      value={form.codigoAgente}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="codigoAgente"
                                      className={checked ? "show" : "hide"}
                                      placeholder={t("sign-in.input-code")}
                                      required={checked ? true : false}
                                    />
                                  </InputContainer>
                                </Row>
                                <Row>
                                  <CheckBoxContainer>
                                    <label className="form-control">
                                      <CustomCheckbox
                                        type="checkbox"
                                        name="over18"
                                        onChange={handleRadioChange}
                                      />
                                      <span>{t("sign-in.confirm-18")}</span>
                                    </label>
                                    <label className="form-control">
                                      <CustomCheckbox
                                        type="checkbox"
                                        name="acceptConditionsPromo"
                                        onChange={handleRadioChange}
                                      />
                                      <span>{t("sign-in.confirm-promo")}</span>
                                    </label>
                                    <label className="form-control">
                                      <CustomCheckbox
                                        type="checkbox"
                                        name="acceptConditions"
                                        onChange={handleRadioChange}
                                      />
                                      <span>
                                        {" "}
                                        {t("sign-in.confirm-terms")
                                          .split("<a>")
                                          .map((el, i) =>
                                            i !== 1 ? (
                                              el
                                            ) : (
                                              <a
                                                href={i18n.language === "en" ? terms : terminos}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: PRIMARY }}
                                              >
                                                {el}
                                              </a>
                                            )
                                          )}
                                      </span>
                                    </label>
                                    {
                                      detectedCountry==='PE' && 
                                    <label className="form-control">
                                      <CustomCheckbox
                                        type="checkbox"
                                        name="acceptConditionsPeru"
                                        onChange={handleRadioChange}
                                        />
                                      <span>{t("sign-in.confirm-peru")}</span>
                                    </label>
                                      }
                                  </CheckBoxContainer>
                                </Row>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                              </React.Fragment>
                            )}
                            <Box style={activeStep === 0 ? {justifyContent:"center"} : {}} sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                              <ButtonStep
                                disabled={activeStep === 0}
                                className={activeStep === 0 ? "hidden" : "btnvolver"}
                                onClick={handleBack}
                                type="button"
                              >
                                {t("sign-in.stepvolver")}
                              </ButtonStep>
                            <Box style={activeStep === 0 ? {display:"none"} : {}} sx={{ flex: '1 1 auto' }} />
                              {activeStep === steps.length - 1 ? 
                              <ButtonStep type="submit" disabled={loading}>
                                {loading ? "CARGANDO..." : t("sign-in.btn-sign-in")}
                              </ButtonStep> : <ButtonStep onClick={handleNext} disabled={activeBtn} type="button">
                                {t("sign-in.stepSiguiente")}
                              </ButtonStep>}
                            </Box>
                        </React.Fragment>
                        )}
                  </Box>
                </Form>
              </Container>
            }
          /> :
          <ModalMobile
            open={registerModal}
            handleClose={confirmClose}
            children={
              <Container>
                <ModalTitle>{t("sign-in.title")}</ModalTitle>
                <ButtonClose onClick={confirmClose}>
                  <CloseIcon/>
                </ButtonClose>
                <Form onSubmit={handleSubmit} autoComplete="off">
                  <Box sx={{ width: '100%' }}>
                    <Stepper activeStep={activeStep}  alternativeLabel sx={{marginBottom:'0rem'}}> 
                      {steps.map((label, index) => {  
                        const stepProps = {};
                        const labelProps = {};

                        if (isStepSkipped(index)) {
                          stepProps.completed = false;
                        }
                        
                        return (
                          <Step key={label} {...stepProps} className={activeStep == index ? "stepactive":"stepno_active"}>
                            <StepLabel {...labelProps} 
                              sx={{
                                "& .MuiStepIcon-root":{
                                  color:"white",
                                  fontWeight: "bold",
                                  fontSize: "28px",
                                },
                                "& .MuiStepIcon-root.Mui-active": {
                                  color: "#ffce05",
                                },
                                "& .MuiStepIcon-text":{
                                  fill: "#000",
                                },
                                "& .MuiStepIcon-root.Mui-completed":{
                                  color:"#2e7d32",
                                },
                                "& .MuiStepLabel-label.Mui-disabled,.MuiStepLabel-label.Mui-completed":{
                                  visibility:"hidden",
                                  opacity: "0",
                                  position: "absolute",
                                  transition: "0s ease-in-out",
                                },
                                ".MuiStepLabel-label":{
                                  fontWeight:"bold!important",
                                  color:"#fff!important",
                                  fontFamily:"'Gotham', 'sans-serif'",
                                  textTransform: "uppercase",
                                  fontSize: "11px",
                                  marginTop:"0.5rem!important",
                                  lineHeight: "1.2",
                                },
                                ".MuiStepIcon-root.Mui-error": {
                                    color: "#d32f2f",
                                },
                              }}
                            >{label}</StepLabel>
                          </Step>
                        );
                      })}
                    </Stepper>
                        {activeStep === steps.length ? (
                          <React.Fragment>
                              <div>
                                All steps completed - you are finished
                              </div>
                              <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                <Box sx={{ flex: '1 1 auto' }} />
                                <Button >Iniciar Sesión</Button>
                              </Box>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                              {activeStep == 0 ? (
                                <React.Fragment>
                                  <Row>
                                    <InputBox
                                      label={t("sign-in.lbl-fullname")}
                                      placeholder={t("sign-in.input-fullname")}
                                      val={form.nombre}
                                      handleChange={handleChange}
                                      handleBlur={handleBlur}
                                      name="nombre"
                                      error={errors.nombre}
                                      type="text"
                                    />
                                    <InputBox
                                      label={t("sign-in.lbl-birth")}
                                      placeholder={t("sign-in.input-birth")}
                                      val={form.fecha_nac}
                                      handleChange={handleChange}
                                      handleBlur={handleBlur}
                                      name="fecha_nac"
                                      error={errors.fecha_nac}
                                      type="date"
                                    />
                                  </Row>
                                  <Row>
                                  <TypeDocument
                                    label={t("sign-in.input-doc")}
                                    val={form.type_doc}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="type_doc"
                                    placeholder={t("sign-in.placeholder-doc")}
                                    error={errors.tipo_doc}
                                    className={showLetraInput ? 'showLetra' : ''}
                                  />

                                  {!showLetraInput &&
                                  <InputBox
                                    label={t("sign-in.lbl-id")}
                                    placeholder={t("sign-in.input-id")}
                                    val={form.cedula}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="cedula"
                                    error={errors.cedula}
                                    type="text"
                                    />
                                    }
                                    {showLetraInput && <InputCL>
                                      <InputBox
                                        label={t("sign-in.lbl-id")}
                                        placeholder={t("sign-in.input-id")}
                                        val={form.cedula}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        name="cedula"
                                        error={errors.cedula}
                                        type="text"
                                      /> 
                                      <Guion>-</Guion>
                                      <InputBox
                                        label={'Letra o Núm'}
                                        placeholder={'Letra o Núm'}
                                        val={form.letraONumero}
                                        handleChange={handleChange}
                                        handleBlur={handleFocusLetra}
                                        name="letraONumero"
                                        error={errorLetra}
                                        type="text"
                                      />
                                    </InputCL> }
                                </Row>
                                </React.Fragment>
                                ) : (
                                <React.Fragment>
                                </React.Fragment>
                              )}
                              {activeStep == 1 ? (
                                <React.Fragment>
                                  <Row>
                                  <CountryBox
                                    label={t("sign-in.input-country")}
                                    val={form.country}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="country"
                                    error={errors.country}
                                    placeholder={t("sign-in.placeholder-country")}
                                  />
                                    <InputBox
                                      label={t("sign-in.input-address")}
                                      placeholder={t("sign-in.placeholder-address")}
                                      val={form.address}
                                      handleChange={handleChange}
                                      handleBlur={handleBlur}
                                      name="address"
                                      error={errors.address}
                                      type="text"
                                    />
                                  </Row>
                                  <Row>
                                  <PhoneBox
                                    value={form.telefono}
                                    handleCountry={handleCountry}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    error={errors.telefono}
                                    mycountry={form.country}
                                    area={form.area}
                                  />
                                    <InputBox
                                      label={t("sign-in.lbl-email")}
                                      placeholder={t("sign-in.input-email")}
                                      val={form.email}
                                      handleChange={handleChange}
                                      handleBlur={handleBlur}
                                      name="email"
                                      error={errors.email}
                                      type="email"
                                    />
                                    
                                  </Row>
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                </React.Fragment>
                              )}
                              {activeStep == 2 ? (
                                <React.Fragment>
                                  <Row>
                                    <InputBox
                                      label={t("sign-in.lbl-user")}
                                      placeholder={t("sign-in.input-user")}
                                      val={form.usuario}
                                      handleChange={handleChange}
                                      handleBlur={handleBlur}
                                      name="usuario"
                                      error={errors.usuario}
                                      type="text"
                                    />
                                    <InputBox
                                      label={t("sign-in.lbl-password")}
                                      placeholder={t("sign-in.input-password")}
                                      val={form.clave}
                                      handleChange={handleChange}
                                      handleBlur={handleBlur}
                                      name="clave"
                                      error={errors.clave}
                                      type="password"
                                    />
                                  </Row>
                                  <Row>
                                  <InputContainer>
                                    <label style={{fontSize: "0.8rem",margin: "0.2rem 0px",textTransform:"uppercase"}}>{t(`password.lbl-4`)}</label>
                                    <div style={{ position: "relative", width: "100%" }}>
                                      <InputConfirmPass
                                        type={showConfirmNewPassword ? "text" : "password"}
                                        value={confirmNewPassword}
                                        placeholder={t(`password.lbl-5`)}
                                        style={{ width: "100%" }}
                                        className={confirmNewPasswordValid ? "error" : "correct"}
                                        onChange={(e) => {
                                          handleConfirmNewPasswordChange(e.target.value);
                                        }}
                                      />
                                      <span
                                        style={{
                                          position: "absolute",
                                          top: "25px",
                                          transform: "translateY(-50%)",
                                          right: "1%",
                                          color:"#ffce05",
                                          cursor:"pointer"
                                        }}
                                        onClick={handleToggleConfirmNewPasswordVisibility}
                                      >
                                        {showConfirmNewPassword ? (
                                          <VisibilityOffIcon />
                                        ) : (
                                          <VisibilityIcon />
                                        )}
                                      </span>
                                      { confirmNewPasswordValid ? (
                                        <WarningPass>
                                          <InfoIcon/>{t("password.error-8")}
                                        </WarningPass>) : ( 
                                          ""
                                      )}
                                      
                                    </div>
                                  </InputContainer>
                                  <SelectBox
                                    label={t("sign-in.lbl-currency")}
                                    val={form.moneda}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    name="moneda"
                                    placeholder={t("sign-in.input-currency")}
                                    error={errors.moneda}
                                  />
                                  </Row>
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                </React.Fragment>
                              )}
                              {activeStep == 3 ? (
                                <React.Fragment>
                                  <Row>
                                    <InputContainer>
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={checked}
                                            onChange={handleCheck}
                                            inputProps={{ "aria-label": "controlled" }}
                                          />
                                        }
                                        label={t("sign-in.lbl-code")}
                                      />
                                      <input
                                        type="text"
                                        value={form.codigoAgente}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        name="codigoAgente"
                                        className={checked ? "show" : "hide"}
                                        placeholder={t("sign-in.input-code")}
                                        required={checked ? true : false}
                                      />
                                    </InputContainer>
                                  </Row>
                                  <Row>
                                    <CheckBoxContainer>
                                      <label className="form-control">
                                        <CustomCheckbox
                                          type="checkbox"
                                          name="over18"
                                          onChange={handleRadioChange}
                                        />
                                        <span>{t("sign-in.confirm-18")}</span>
                                      </label>
                                      <label className="form-control">
                                        <CustomCheckbox
                                          type="checkbox"
                                          name="acceptConditionsPromo"
                                          onChange={handleRadioChange}
                                        />
                                        <span>{t("sign-in.confirm-promo")}</span>
                                      </label>
                                      <label className="form-control">
                                        <CustomCheckbox
                                          type="checkbox"
                                          name="acceptConditions"
                                          onChange={handleRadioChange}
                                        />
                                        <span>
                                          {" "}
                                          {t("sign-in.confirm-terms")
                                            .split("<a>")
                                            .map((el, i) =>
                                              i !== 1 ? (
                                                el
                                              ) : (
                                                <a
                                                  href={i18n.language === "en" ? terms : terminos}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  style={{ color: PRIMARY }}
                                                >
                                                  {el}
                                                </a>
                                              )
                                            )}
                                        </span>
                                      </label>
                                      {
                                      detectedCountry==='PE' && 
                                    <label className="form-control">
                                      <CustomCheckbox
                                        type="checkbox"
                                        name="acceptConditionsPeru"
                                        onChange={handleRadioChange}
                                        />
                                      <span>{t("sign-in.confirm-peru")}</span>
                                    </label>
                                      }
                                    </CheckBoxContainer>
                                  </Row>
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                </React.Fragment>
                              )}
                              <Box style={activeStep === 0 ? {justifyContent:"center"} : {}} sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                <ButtonStep
                                  disabled={activeStep === 0}
                                  className={activeStep === 0 ? "hidden" : "btnvolver"}
                                  onClick={handleBack}
                                  type="button"
                                >
                                 {t("sign-in.stepvolver")}
                                </ButtonStep>
                                <Box sx={{ flex: '1 1 auto' }} />
                                {activeStep === steps.length - 1 ? 
                                <ButtonStep type="submit" disabled={loading}>
                                  {loading ? "CARGANDO..." : t("sign-in.btn-sign-in")}
                                </ButtonStep> : 
                                <ButtonStep onClick={handleNext} disabled={activeBtn} type="button">
                                  {t("sign-in.stepSiguiente")}
                                </ButtonStep>}
                              </Box>
                          </React.Fragment>
                          )}
                    </Box>
                </Form>
              </Container>
            }
          />
        }
      </>
    )
  );
};

export default Register;